import { openBlock as c, createElementBlock as l, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(r, e) {
  return c(), l("svg", t, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M3.525 6.9C5.33 4.73 7.266 3.346 10.08 2.88c2.58-.231 5.074.183 7.185 1.755 2.222 1.913 3.635 4.086 3.917 7.057.097 2.452-.431 4.915-2.04 6.826-1.97 2.062-3.848 3.415-6.754 3.62-3.06.06-5.501-.613-7.828-2.698C1.54 15.9.747 10.878 3.525 6.9M3.12 12h3.84l.124-.905c.314-2.192.652-4.252 1.556-6.295-1.681.242-2.8 1.236-3.856 2.526-1.05 1.53-1.45 2.837-1.664 4.674m2.16 6.24c1.035.957 2.03 1.676 3.36 2.16l-.209-.602a42 42 0 0 1-.766-2.728l-.126-.487c-.283-1.124-.454-2.23-.579-3.383H3.12c0 1.857.982 3.666 2.16 5.04m4.8 1.92c.677.605.677.605 1.545.72 1.213-.473 1.816-1.322 2.34-2.475.63-1.68.735-3.432.915-5.205H8.16c0 2.42.391 4.998 1.92 6.96M8.16 12h6.72c-.293-4.016-.293-4.016-2.265-7.399-.446-.334-.784-.444-1.335-.521-1.125.404-1.6 1.191-2.127 2.208C8.398 8.147 8.16 10.006 8.16 12m6.24 8.4c2.172-1.011 3.702-2.144 4.8-4.32.307-.957.516-1.893.72-2.88h-3.84l-.124.86c-.286 1.898-.557 3.684-1.371 5.44-.217.417-.217.417-.185.9m0-15.36.185.365C15.54 7.506 15.773 9.733 16.08 12h3.84c-.429-2.77-1.43-4.667-3.6-6.48-.756-.5-.756-.5-1.44-.72z"
    }, null, -1)
  ])]);
}
const s = { render: n };
export {
  s as default,
  n as render
};
